<template>
    <div class="main-status-setting">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-1">Preferred Banks</h2>
                    <p>We'll prioritize these banks when they are available.</p>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <b-card no-body>    
                <div class="row p-4" v-if="tableData.length > 0">
                    <div class="w-100 d-flex justify-content-between">
                        <b-col md="3">
                            <base-input
                                v-model="searchQuery"
                                prepend-icon="fas fa-search"
                                placeholder="Search..."
                                >
                            </base-input>
                        </b-col>
                        <div class="px-3">
                            <el-button class="bg-primary text-white" @click="savePreferredBanks" :loading="is_loading_save">Save</el-button>
                        </div>
                    </div>
                    <div class="w-100 table-listings px-3">
                        <el-table 
                            ref="multipleTable"
                            v-loading="isTableLoading"
                            :data="queriedData"
                            style="width: 100%;"
                        >
                            <el-table-column
                                label="#"
                                type="index" 
                                width="100"
                            ></el-table-column>

                            <el-table-column
                                prop="code"
                                width="200"
                                label="Bank Code"
                                sortable
                            >
                            <template slot-scope="scope">
                                <span :class="preffered_banks.findIndex((item) => item.bank_id == scope.row.bank_id) === -1 ? '':'font-weight-bold'">{{ scope.row.code }}</span>
                            </template>
                            </el-table-column>
                
                            <el-table-column
                                prop="name"
                                label="Bank Name"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <span :class="preffered_banks.findIndex((item) => item.bank_id == scope.row.bank_id) === -1 ? '':'font-weight-bold'">{{ scope.row.name }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column
                                :label="'Set Preferred - '+ preffered_banks.length +'/' + prefferedLimit"
                            >
                            <template slot-scope="scope">
                                <button class="btn-sm border-0 shadow-none" 
                                :class="preffered_banks.findIndex((item) => item.bank_id == scope.row.bank_id) === -1 ? 'btn-secondary' : 'btn-success'"
                                @click="togglePreffered(scope.row)">
                                    <h5 class="m-0">
                                        <b-icon icon="hand-thumbs-up-fill" 
                                            :class="preffered_banks.findIndex((item) => item.bank_id == scope.row.bank_id) === -1 ? '' : 'text-white'"
                                        ></b-icon>
                                    </h5>
                                </button>
                            </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </b-card>
        </b-container>
    </div>
</template>

<script>
import { Table, TableColumn, Tabs, TabPane, Button } from 'element-ui'
import {
    axios,
    services,
    getHeader,
    notifyFunctionMixin,
    helperFunctionMixin,
} from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useConfigStore } from '@/stores/configStore'
import {sortBy} from 'lodash'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'

export default {
    components: {
        BasePagination,
        [Button.name]: Button,
        [TableColumn.name]: TableColumn,
        [Table.name]: Table,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin,
        clientPaginationMixin
    ],
    data() {
        return {
            propsToSearch:['code','name'],
            isTableLoading: false,
            tableData: [],
            preffered_banks:[],
            is_loading_save: false,
            vps_blocked_bank_codes: [
                'Koperasi',
                'Houzkey',
                'OCBC',
                'AEON Credit',
                'Agro',
                // 'Al Rajhi',
                'Kuwait',
                'OTB',
                'AXIATA'
            ]
        };
    },
    computed:{
      ...mapState(useAuthStore, ['auth_user']),
      ...mapState(useConfigStore, ['app_code']),
      prefferedLimit(){
        return this.auth_user.subscription.privileges.scpk_limit_bank
      }
    },
    async created() {
        await this.getBanks()
        this.getPrefferedBanks()
    },
    methods: {
        ...mapActions(useAuthStore, ['fetchUserInfo']),
        async getBanks(){
            const res = await this.getLookupTables(['banks'])
            const banks = res.banks
            if(this.checkAppCode('vps')){
                this.tableData = banks.filter((item) => !this.vps_blocked_bank_codes.includes(item.code))
            }else{
                this.tableData = banks
            }
        },
        togglePreffered(bank){
            // if bank exists, remove from preffered, else add
            const existingBankIndex = this.preffered_banks.findIndex((item) => item.bank_id == bank.bank_id)
            if(existingBankIndex === -1){
                // check for limit
                if(this.preffered_banks.length >= this.prefferedLimit){
                    this.errorFunction(null, 'Max preferred banks:  '+this.prefferedLimit)
                }else{
                    this.preffered_banks.push(bank)
                }
            }else{
                this.preffered_banks.splice(existingBankIndex, 1)
            }
        },
        savePreferredBanks(){
            this.is_loading_save = true
            const subId = this.auth_user.subscription.scrb_id
            
            let scrb_banks = []
            this.preffered_banks.forEach((item) => {
                scrb_banks.push({
                    bank_id: item.bank_id,
                    bank_code: item.code
                })
            })

            axios.post(services.billing + 'subscription/update-banks/' + subId, {scrb_banks:scrb_banks}, {headers:getHeader()})
                .then(async(res) => {
                    await this.fetchUserInfo()
                    this.getPrefferedBanks()
                    this.is_loading_save = false
                    this.notifySuccess('<b>Preferred Banks</b> - Successfully Updated.')
                })
                .catch(e => {
                    this.is_loading_save = false
                    this.errorFunction(e)
                })
        },
        getPrefferedBanks(){
            this.auth_user.subscription.scrb_banks.forEach((item) => {
                const existingBank = this.preffered_banks.find((bank) => bank.bank_id == item.bank_id)
                if(!existingBank){
                    this.preffered_banks.push({
                        bank_id: item.bank_id,
                        code: item.bank_code
                    })
                }
            })
        }
    }
}
</script>